export default "/images/f6fb40051d8b5d703e3531ed94451885.avif";